(function () {
  if (window.__SUNHAUK_SOCIAL_PROOF_INLINE_INIT__) return;
  window.__SUNHAUK_SOCIAL_PROOF_INLINE_INIT__ = true;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function toInt(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  }

  function getStoreDayKey(timeZone) {
    try {
      var formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone || 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      var parts = formatter.formatToParts(new Date());
      var map = {};

      parts.forEach(function (part) {
        map[part.type] = part.value;
      });

      return map.year + '-' + map.month + '-' + map.day;
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function hashString(input) {
    var hash = 2166136261;

    for (var i = 0; i < input.length; i += 1) {
      hash ^= input.charCodeAt(i);
      hash +=
        (hash << 1) +
        (hash << 4) +
        (hash << 7) +
        (hash << 8) +
        (hash << 24);
    }

    return hash >>> 0;
  }

  function seededRange(seed, min, max) {
    if (max < min) {
      var temp = min;
      min = max;
      max = temp;
    }

    var hash = hashString(seed);
    var range = max - min + 1;

    return min + (hash % range);
  }

  onReady(function () {
    var pills = document.querySelectorAll('[data-sh-social-proof-pill]');
    if (!pills.length) return;

    var params = new URLSearchParams(window.location.search);
    var debugMode =
      params.has('sh_social_debug') ||
      params.get('sh_social_debug') === '1' ||
      params.get('sh_social_debug') === 'true';

    pills.forEach(function (pill) {
      var productId = pill.getAttribute('data-product-id');
      var productTitle = pill.getAttribute('data-product-title') || 'this product';
      var timeZone = pill.getAttribute('data-time-zone') || 'America/New_York';
      var salt = pill.getAttribute('data-salt') || 'sunhauk-social-proof-inline-v1';

      if (!productId) return;

      var min = toInt(pill.getAttribute('data-count-min'), 35);
      var max = toInt(pill.getAttribute('data-count-max'), 95);

      if (min < 1) min = 1;
      if (max < 1) max = 1;

      var dayKey = getStoreDayKey(timeZone);
      var seed = productId + '|' + dayKey + '|purchase-count|' + salt;
      var count = seededRange(seed, min, max);

      var countEl = pill.querySelector('[data-sh-social-proof-count]');
      var titleEl = pill.querySelector('[data-sh-social-proof-title]');

      if (countEl) {
        countEl.textContent = count;
      }

      if (titleEl) {
        titleEl.textContent = productTitle;
      }

      if (debugMode) {
        pill.setAttribute('data-debug', 'true');

        console.info('[Sunhauk Inline Social Proof]', {
          productId: productId,
          productTitle: productTitle,
          dayKey: dayKey,
          min: min,
          max: max,
          count: count,
          timeZone: timeZone
        });
      }

      pill.classList.add('is-ready');
    });
  });
})();